import { Autocomplete, TextField, Typography } from "./MyCustomFile"
export const MySelect = ({ name, label, value, onChange, options, error, onBlur, helperText, disabled, status = false }) => {
    const handleValueChange = (_event, newValue) => {
        if (newValue && newValue.value) {
            onChange({ target: { name, value: newValue.value } });
        } else {
            onChange({ target: { name, value: '' } });
        }
    };
    return (<>
        <Autocomplete
            disablePortal margin="dense" size="small" sx={{ mt: 1 }}
            options={options || []}
            getOptionLabel={(option) => option.label}
            value={Array.isArray(options) && options?.find((option) => option?.value == value) || null}
            onChange={handleValueChange} name={name}
            disabled={Boolean(disabled)}
            renderInput={(params) => <TextField {...params} label={`${label}${status ? "*" : ""}`} error={error} onBlur={onBlur} helperText={''} />}
        />
        {error && (<Typography variant="body2" style={{ color: "red", fontSize: "10px", marginLeft: "0" }}>{helperText}</Typography>)}
    </>);
}